import { render, staticRenderFns } from "./EntradaCompraComponent.vue?vue&type=template&id=c80e5f02&"
import script from "./EntradaCompraComponent.vue?vue&type=script&lang=js&"
export * from "./EntradaCompraComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports